import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatDialog} from '@angular/material/dialog';
import {NotificationService} from '../../services/notification.service';
import {ScoreService} from '../../services/score.service';
import {MatPaginator} from '@angular/material/paginator';
import {Questions} from '../../domain/questions';
import {AddQuestionDialogComponent} from '../question-config/add-question-dialog/add-question-dialog.component';
import {ConfirmDialogComponent} from '../../components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'tech-core-quiz-user-config',
  standalone: false,
  templateUrl: './score-config.component.html',
  styleUrl: './score-config.component.scss'
})
export class ScoreConfigComponent implements OnInit, AfterViewInit {

  public displayedColumns = ['userName', 'score', 'actions'];
  public dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator!: MatPaginator;


  constructor(
    private scoreService: ScoreService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
  ) {
  }

  ngOnInit(): void {
    this.loadScores()
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  loadScores() {
    this.scoreService.getAllScores().subscribe({
      next: data => {
        this.dataSource.data = data
      }
    })
  }

  deleteScore(username: string) {
    this.openConfirmDialog(username)
  }

  openConfirmDialog(username: string) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'dialog-container-custom',
      disableClose: true,
      width: '300px',
      height: '180px',
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((response) => {
      switch (response.status) {
        case "ok":
          this.scoreService.deleteScore(username).subscribe({
            next: value => {
              this.loadScores()
              this.notificationService.success('User was deleted!')
            }
          })
          break;
        case "closed":
          break;
      }
    });
  }

}
